import React from 'react';
import { IconProps } from '../types';

interface CustomIconProps extends IconProps {
  viewBox?: string;
  role?: string;
  'aria-hidden'?: boolean;
}

export const SsfOpenOff = React.memo<CustomIconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
    width,
    height,
    role = 'img',
    'aria-hidden': ariaHidden = false,
  }) => (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width ?? size}
      height={height ?? size}
      className={className}
      onClick={onClick}
      role={role}
      aria-hidden={ariaHidden}
      style={{ cursor: onClick ? 'pointer' : 'inherit' }}
    >
      <path
        d="M2.91406 10L7.5 10"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M4.25 7.25L1.5 10L4.25 12.75"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M17.0859 10L12.5 10"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <path
        d="M15.75 7.25L18.5 10L15.75 12.75"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <rect
        x="8"
        y="3"
        width="4"
        height="14"
        rx="2"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  ),
);

SsfOpenOff.displayName = 'SsfOpenOff';
